import React, { useEffect, useState } from 'react';
import { ArrowUp, MessageCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { HeroSlider } from './components/HeroSlider';
import { NewsTicker } from './components/NewsTicker';
import { WelcomeSection } from './components/WelcomeSection';
import { MessageSection } from './components/MessageSection';
import { KeyHighlights } from './components/KeyHighlights';
import { UpcomingEvents } from './components/UpcomingEvents';
import { NoticeBoard } from './components/NoticeBoard';
import { RecentNews } from './components/RecentNews';
import { ExtraCurricular } from './components/ExtraCurricular';
import { Gallery } from './components/Gallery';
import { Achievements } from './components/Achievements';
import { AdmissionBanner } from './components/AdmissionBanner';
import { Footer } from './components/Footer';
export function App() {
  const [showBackToTop, setShowBackToTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <HeroSlider data-id="element-2" />
      <NewsTicker data-id="element-3" />
      <WelcomeSection data-id="element-4" />
      <MessageSection data-id="element-5" />
      <KeyHighlights data-id="element-6" />
      <AdmissionBanner data-id="element-7" />
      <UpcomingEvents data-id="element-8" />
      <NoticeBoard data-id="element-9" />
      <RecentNews data-id="element-10" />
      <ExtraCurricular data-id="element-11" />
      <Gallery data-id="element-12" />
      <Achievements data-id="element-13" />
      <Footer data-id="element-14" />

      {/* Back to Top Button */}
      <AnimatePresence data-id="element-15">
        {showBackToTop && <motion.button initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.8
      }} onClick={scrollToTop} className="fixed bottom-24 right-6 bg-primary hover:bg-primary-dark text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all z-40" data-id="element-16">
            <ArrowUp size={24} data-id="element-17" />
          </motion.button>}
      </AnimatePresence>

      {/* Floating Help Button */}
      <button className="fixed bottom-6 right-6 bg-gold hover:bg-gold/90 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all z-40" data-id="element-18">
        <MessageCircle size={24} data-id="element-19" />
      </button>
    </div>;
}